import { KikErrorResponse, KikResponseMessage } from "@kikocosmeticsorg/uc-api-nest-common-fe";

export class ErrorResponse<T = any> extends KikErrorResponse<T> {
  constructor(messages?: KikResponseMessage[], errorCode?: number, status?: number, data?: T) {
    super(messages, errorCode, status, data);
  }
}
